import { render, staticRenderFns } from "./WindowContent.vue?vue&type=template&id=7ccaed1a&scoped=true&"
import script from "./WindowContent.vue?vue&type=script&lang=js&"
export * from "./WindowContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccaed1a",
  null
  
)

export default component.exports